import Telemetry from '@atlassian/mpac-telemetry';
export const ViewSearchResult = Telemetry.createGenericTask('view-search-results');
export const ViewFilters = Telemetry.createGenericTask('view-filters');
export const SearchResultPageTask = Telemetry.createPageViewTask('view-search-results-page').dependsOn([ViewSearchResult, ViewFilters]);